package ru.villawonka.app.resources.strings

import ru.villawonka.app.domain.model.LanguageDomain

object StringFactory {
    fun createStrings(language: LanguageDomain): StringResources =
        when (language) {
            LanguageDomain.RU -> RuStringResources()
            LanguageDomain.EN -> EnStringResources()
        }
}